<template>
  <div class="bigBox">
    <div class="banner">
      <div style="height: 100%;" v-if="list.length">
        <div class="swiper"  v-if="list.length === 1" >
          <a :href="list[0].link" target="_blank" v-if="list[0].link">
           <div :style='{ backgroundImage: "url(" + list[0].img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
          </a>
          <div v-else :style='{ backgroundImage: "url(" + list[0].img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
        </div>
        <swiper :options="swiperOption" class="swiper" v-if="list.length > 1">
          <swiper-slide v-for="(item,index) in list" :key="index">
            <a :href="item.link" target="_blank" v-if="item.link">
              <div :style='{ backgroundImage: "url(" + item.img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
            </a>
            <div v-else :style='{ backgroundImage: "url(" + item.img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>

    </div>
    <div class="content">
      <div class="cont c-title">
        <img src="../../assets/img/001.png" />
      </div>
      <div class="cont c-link">
        <img src="../../assets/img/002.png" />
      </div>
      <div class="cont c-btn">
        <img src="../../assets/img/003.png" @click="toMaps" style="cursor: pointer;" />
      </div>
      <div class="cont c-footer">
        <img src="../../assets/img/004.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { index } from "@/api/common.js";

export default {
  name: "index",
  mounted() {
    this.getBannerList();
  },
  data() {
    return {
      //广告
      list: [],
      swiperOption: {
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  methods: {
    getBannerList() {
      index("urgentadMaps", { position: 0 }).then(res => {
        this.list = res.data.rows;
      });
    },
    toMaps() {
      this.$router.push({
        path: "/maps"
      });
    }
  }
};
</script>

<style scoped>
html,
#app,
.bigBox {
  height: 100%;
  min-height: 920px;
  width: 100%;
  background-image: url("../../assets/img/bgc.png");
  background-size: cover;
  background-position: center;
  overflow: hidden;
}
.title {
  width: 70%;
  height: 10%;
  margin: 0 auto;
  background-image: url("../../assets/img/001.png");
  background-size: 100% 100%;
}
.line {
  width: 40%;
  height: 2%;
  margin: 10px auto 0;
  background-image: url("../../assets/img/002.png");
  background-size: 100% 100%;
}
.btn {
  width: 20%;
  height: 10%;
  margin: 5% auto 0;
  background-image: url("../../assets/img/003.png");
  background-size: 100% 100%;
  cursor: pointer;
}
.footer {
  width: 29%;
  height: 16%;
  margin: 10% auto 0;
  background-image: url("../../assets/img/004.png");
  background-size: 100% 100%;
}
.banner {
  width: 100%;
  height: 215px;
}
.swiper {
  height: 100%;
}
.swiper-pagination {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.cont {
  width: 70%;
  margin: 0 auto;
}
.c-title {
  margin: 40px auto;
}
.c-link {
  width: 40%;
  margin: 20px auto;
}
.c-btn {
  width: 20%;
  margin: 60px auto;
}
.c-footer {
  width: 30%;
  margin: 100px auto;
}

.cont img {
  width: 100%;
  height: auto;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
  .cont {
    width: auto;
    margin: 0 20px;
  }
  .c-title,
  .c-link {
    width: 90%;
    margin: 10px auto;
  }
  .c-link {
    width: 65%;
  }
  .c-btn {
    width: 40%;
    margin: 40px auto;
  }
  .c-footer {
    margin-top: 70px;
  }
  .content {
    min-height: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>
<style>
@media screen and (min-width: 320px) and (max-width: 980px) {
  .bigBox {
    min-height: 100%;
    /*padding-top: 0;*/
  }

  .cont {
    width: auto;
    margin: 0 20px;
  }
}
</style>